import { useRef, useState } from 'react';
import { useInView } from 'motion/react';
import { motion } from 'motion/react';
import { IconButton, Stack } from '@mui/material';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import RedditIcon from '@mui/icons-material/Reddit';
import SectionLayout from './SectionLayout';

const socials = [
  { icon: <GitHubIcon sx={{ fontSize: 36 }} />, href: 'https://github.com/tarylb', label: 'GitHub' },
  { icon: <LinkedInIcon sx={{ fontSize: 36 }} />, href: 'https://www.linkedin.com/in/taryl-brown', label: 'LinkedIn' },
  { icon: <RedditIcon sx={{ fontSize: 36 }} />, href: 'https://www.reddit.com/user/tasty__cakes', label: 'Reddit' },
];

const PULSE = 1.0; // seconds per button; the wave steps one button per PULSE

function SocialSection({ socialRef, onScrollUp, onScrollDown, style }) {
  const inViewRef = useRef(null);
  const inView = useInView(inViewRef, { amount: 0.3 });
  const [paused, setPaused] = useState(false);

  const setRefs = (el) => {
    socialRef.current = el;
    inViewRef.current = el;
  };

  return (
    <SectionLayout
      sectionRef={setRefs}
      style={style}
      onScrollUp={onScrollUp}
      onScrollDown={onScrollDown}
      arrowsVisible={inView}
    >
      <Stack spacing={3} alignItems="center">
        <h2 style={{ fontSize: '36px', margin: 0, textShadow: '0 0 18px rgba(255,255,255,0.45)' }}>Find Me Online</h2>
        <Stack direction="row" spacing={3}>
          {socials.map(({ icon, href, label }, i) => (
            <motion.div
              key={label}
              whileHover={{ scale: 1.15 }}
              onHoverStart={() => setPaused(true)}
              onHoverEnd={() => setPaused(false)}
              onFocus={() => setPaused(true)}
              onBlur={() => setPaused(false)}
              animate={paused ? { scale: 1 } : { scale: [1, 1.12, 1] }}
              transition={paused
                ? { duration: 0.3, ease: 'easeOut' }
                : {
                  duration: PULSE,
                  times: [0, 0.5, 1],
                  ease: 'easeInOut',
                  repeat: Infinity,
                  repeatDelay: (socials.length - 1) * PULSE,
                  delay: i * PULSE,
                }}
            >
              <IconButton
                component="a"
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                sx={{
                  color: 'white',
                  border: '2px solid white',
                  width: 72,
                  height: 72,
                  '&:hover': { borderColor: 'white', backgroundColor: 'rgba(255,255,255,0.1)' },
                }}
              >
                {icon}
              </IconButton>
            </motion.div>
          ))}
        </Stack>
      </Stack>
    </SectionLayout>
  );
}

export default SocialSection;
